<template>
  <div :key="$store.getters['resource/currentResource'].key">
    <help :text="$t('help.invite_create')" :title="$t('help.invite_create_title')"/>
    <div class="white-container">
      <invite-view @save="saveInvite"/>
    </div>
  </div>
</template>

<script>
  import InviteView from "./InviteView.vue";

  export default {
    components: {
      InviteView
    },
    name: 'InviteCreation',
    props: {
      caption: {
        type: String,
      },
    },
    methods: {
      saveInvite(params) {
        this.postData('invites', params, '/invites');
      }
    }
  }
</script>